<script>
export default {
    name: '',
    components: {
    },
    props: {
		current: Number,
	},
	watch: {
		current(newVal, oldVal) {
			if (newVal === 1) {
				this.list  = this.list1.map(item => {
                    return {
                        ...item,
                        value: parseFloat(Math.abs(item.value)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                    }
                })
			} else if (newVal === 0) {
				this.list = this.list0.map(item => {
                    return {
                        ...item,
                        value: parseFloat(Math.abs(item.value)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                    }
                })
			}
		}
	},
    data() {
        return {
            list: [],
            list0: [
                {name: '当前授信金额', value: '378587476', leftIcon: '', unit: '元'},
                {name: '累计授信金额', value: '456007079', leftIcon: '', unit: '元'},
                {name: '贷款余额', value: '30480069', leftIcon: '', unit: '元'},
                {name: '总贷款余额', value: '50893200', leftIcon: '', unit: '元'},
                {name: '签约数量', value: '309087', leftIcon: '', unit: '件'},
                {name: '总签约数量', value: '503029', leftIcon: '', unit: '件'},
                {name: '白名单户数', value: '2864', leftIcon: '', unit: '户'},
                {name: '白名单总户数', value: '4500', leftIcon: '', unit: '户'},
            ],
            list1: [
                {name: '当前授信金额', value: '20331570000', leftIcon: '', unit: '元'},
                {name: '累计授信金额', value: '91643450000', leftIcon: '', unit: '元'},
                {name: '贷款余额', value: '153211968.9', leftIcon: '', unit: '元'},
                {name: '总贷款余额', value: '393098726.4', leftIcon: '', unit: '元'},
                {name: '签约数量', value: '2494', leftIcon: '', unit: '件'},
                {name: '总签约数量', value: '9011', leftIcon: '', unit: '件'},
                {name: '白名单户数', value: '60018', leftIcon: '', unit: '户'},
                {name: '白名单总户数', value: '269576', leftIcon: '', unit: '户'},
            ]
        }
    },
    mounted() {
        this.list = this.list0.map(item => {
        return {
            ...item,
            value: parseFloat(Math.abs(item.value)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
    })
    }
}
</script>

<template>
    <div class="text-msg">
        <div class="text-div default-color">
            <div v-for="item in list" :key="item.name" class="d-flex item-center info d-flexitem-center ju-between">
                <div class="d-flex item-center" style="margin-left: 10px;">
                    <div class="circle"></div>
                    <div class="f-20" style="margin-left: 6px;">{{ item.name }} &nbsp;/&nbsp; {{ item.unit }} </div>
                </div>
                <div class="value-color f-24 fw-600">{{ item.value }}</div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.text-msg{
    width: 100%;
    height: 100px;
    .text-div{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 10px;
        justify-items: center;
        .circle{
            width: 6px;
            height: 6px;
            background: green;
        }
        .info{
            width: 90%;
            height: 42px;
            font-size: 24px;
            border-bottom: 1px solid rgba(225, 225, 219, .4);
        }
        .value-color{
            color: rgba(73, 160, 208, 1);
        }
    }
}
</style>
